import { useCallback } from 'react'
import { useModalContext } from 'contexts/ModalProvider'

export const useModal = id => {
  const { showModal, hideModal, modals } = useModalContext()

  const show = useCallback(config => showModal(id, config), [id, showModal])
  const hide = useCallback(() => hideModal(id), [id, hideModal])
  const isVisible = modals.some(modal => modal.id === id && modal.visible)

  return { show, hide, isVisible }
}
